// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  connectAuthEmulator,
} from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAHl4lGQnwWA6HHBg-ReFEjNQ3UVGBxmD8",
  authDomain: "river-ranch-poker.firebaseapp.com",
  projectId: "river-ranch-poker",
  storageBucket: "river-ranch-poker.firebasestorage.app",
  messagingSenderId: "494633759487",
  appId: "1:494633759487:web:551b5f02dce12c883912ca",
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);

// ✅ Important: export this so we can await auth rehydration before routing decisions
const authReady = setPersistence(auth, browserLocalPersistence);

/**
 * Emulator wiring (OPTIONAL)
 * Turn on only when you WANT it, by setting:
 *   REACT_APP_USE_EMULATORS=true
 *
 * In normal localhost:3000 dev, keep it OFF so real login works.
 */
const useEmulators =
  process.env.REACT_APP_USE_EMULATORS === "true" ||
  process.env.REACT_APP_USE_EMULATORS === "1";

if (useEmulators) {
  // Prevent double-connecting during hot reload
  // (Firebase throws if you connect twice)
  if (!auth._canInitEmulator) {
    auth._canInitEmulator = true;
  }

  try {
    connectAuthEmulator(auth, "http://127.0.0.1:9099", {
      disableWarnings: true,
    });
  } catch (e) {
    // ignore if already connected
  }

  try {
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
  } catch (e) {}

  try {
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  } catch (e) {}
}

export { app, db, auth, functions, authReady };